import { render, staticRenderFns } from "./lista_gestionpagare.vue?vue&type=template&id=49542f79&scoped=true"
import script from "./lista_gestionpagare.vue?vue&type=script&lang=js"
export * from "./lista_gestionpagare.vue?vue&type=script&lang=js"
import style0 from "./lista_gestionpagare.vue?vue&type=style&index=0&id=49542f79&prod&scoped=true&lang=css"
import style1 from "./lista_gestionpagare.vue?vue&type=style&index=1&id=49542f79&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49542f79",
  null
  
)

export default component.exports